module.exports = __webpack_public_path__ + "img/watermask_img_unshelve_e@3x.f602852b.png";